import React from "react";

const IN = "min-h-[48px] rounded border border-erf-borderCream px-3 bg-white text-base w-full";

// One quick-add row list for any report section. cols: [{ key, label, type?: "number"|"checkbox"|"select", options? }]
export default function SectionRows({ id, title, cols, rows, blank, onChange, readOnly }) {
  const set = (i, k, v) => onChange(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  const cell = (r, i, c) => {
    const tid = `field-${id}-${i}-${c.key}`;
    if (c.type === "checkbox") return <input type="checkbox" className="h-6 w-6" checked={!!r[c.key]} disabled={readOnly} onChange={(e) => set(i, c.key, e.target.checked)} data-testid={tid} />;
    if (c.type === "select") return (
      <select className={IN} value={r[c.key]} disabled={readOnly} onChange={(e) => set(i, c.key, e.target.value)} data-testid={tid}>
        {c.options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>);
    return <input className={IN} type={c.type === "number" ? "number" : "text"} inputMode={c.type === "number" ? "decimal" : undefined} value={r[c.key] ?? ""} readOnly={readOnly}
      onChange={(e) => set(i, c.key, c.type === "number" ? (e.target.value === "" ? "" : Number(e.target.value)) : e.target.value)} data-testid={tid} />;
  };
  return (
    <fieldset className="space-y-2" data-testid={`field-section-${id}`}>
      <legend className="font-heading text-lg">{title}</legend>
      {rows.map((r, i) => (
        <div key={i} className="grid gap-2 sm:grid-cols-[repeat(auto-fit,minmax(120px,1fr))_auto] items-end border-b border-erf-borderCream pb-2">
          {cols.map((c) => <label key={c.key} className="text-xs flex flex-col gap-1">{c.label}{cell(r, i, c)}</label>)}
          {!readOnly && <button type="button" aria-label={`Remove ${title} row ${i + 1}`} onClick={() => onChange(rows.filter((_, j) => j !== i))}
            className="min-h-[48px] min-w-[48px] rounded border border-erf-borderCream text-sm" data-testid={`field-${id}-${i}-remove`}>✕</button>}
        </div>
      ))}
      {!readOnly && <button type="button" onClick={() => onChange([...rows, { ...blank }])} className="min-h-[48px] px-4 rounded-sm border border-dashed border-erf-dark/40 text-sm font-semibold w-full sm:w-auto"
        data-testid={`field-${id}-add`}>+ Add {title.toLowerCase()}</button>}
    </fieldset>
  );
}
